import { css } from 'linaria';
import { FavoriteIcon } from '@pocket/web-ui';
import { buttonReset } from 'components/buttons/button-reset';
import { tagBase } from './tags';
import classNames from 'classnames';
const favoriteWrapper = "f166jgra";
export function FavoriteTag({
  margin
}) {
  const className = classNames(favoriteWrapper, buttonReset, tagBase);
  return <div className={className} style={{
    margin
  }}>
      <FavoriteIcon />
    </div>;
}

require("../../../.linaria-cache/src/components/tags/tag-favorite.linaria.module.css");